import { BellOutlined } from "@ant-design/icons"
import { Button, Flex, Space, Typography } from "antd"
import React from "react"

const { Title, Text } = Typography

export function ContractsHeader() {
  return (
    <Flex justify={"space-between"} align={"center"} gap={"small"}>
      <Flex align={"center"}>
        <Flex vertical>
          <Title className={"text-start"} level={2}>
            Contract Review
          </Title>
          <Text type={"secondary"}>Review and approve contract documents</Text>
        </Flex>
      </Flex>
      {/*<Space>*/}
      {/*  <Button disabled icon={<BellOutlined />} />*/}
      {/*</Space>*/}
    </Flex>
  )
}
